import { Controller } from 'stimulus'
import '@stimulus/polyfills'

export default class extends Controller {
  static targets = ['areaLink', 'headingSuffix']

  switchTab(event) {
    const button = event.currentTarget
    const tabKey = button.dataset.tabKey
    const order = button.dataset.order
    const tabSource = button.dataset.tabSource

    // タブのアクティブ状態を切り替え
    this.element.querySelectorAll('.top-search-client__tab').forEach(tab => {
      tab.classList.remove('top-search-client__tab--active')
    })
    button.classList.add('top-search-client__tab--active')

    // 見出しの末尾をタブのラベルに更新
    if (this.hasHeadingSuffixTarget) {
      this.headingSuffixTarget.textContent = button.textContent.trim()
    }

    // 全てのエリアリンクのhrefを更新
    this.areaLinkTargets.forEach(link => {
      const basePath = link.dataset.basePath
      link.href = this.buildUrl(basePath, tabKey, order, tabSource)
    })
  }

  buildUrl(basePath, tabKey, order, tabSource) {
    // ランキングタブの場合は /ranking パスに変換
    if (tabKey === 'ranking') {
      return `${basePath}/ranking${tabSource ? `?tab_source=${tabSource}` : ''}`
    }

    // エリアタブ（標準）の場合はパラメータなし
    if (tabKey === 'area') {
      return basePath
    }

    // その他のタブの場合は order と tab_source パラメータを付与
    const params = []
    if (order) {
      params.push(`order=${order}`)
    }
    if (tabSource) {
      params.push(`tab_source=${tabSource}`)
    }

    if (params.length > 0) {
      return `${basePath}?${params.join('&')}`
    }

    return basePath
  }
}
